module.exports = __webpack_public_path__ + "static/media/arrow_down.29bf3a57.svg";